<template>
  <v-card>
    <v-row style="width: 100%;">
      <v-col class="pt-0">
        <v-form @submit.prevent="searchProducts">
          <v-layout row>
            <v-text-field
              v-model="searchQuery.name_or_identification_code_cont"
              label="商品名もしくは商品コード"
              style="max-width: 500px"
              clearable
              class="ml-6 col-md-9"
            ></v-text-field>
            <v-btn
              color="primary"
              dark
              tile
              outlined
              class="ma-2"
              type="submit"
              @submit.prevent="infiniteHandler"
              >検索</v-btn
            >
          </v-layout>
        </v-form>
        <v-simple-table fixed-header>
          <thead>
            <tr>
              <th class="text-center" style="width: 80px">商品ID</th>
              <th class="text-center" style="min-width: 80px">商品コード</th>
              <th style="width: 100px"></th>
              <th class="text-left" style="min-width: 150px">商品名</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="product in products" :key="product.id">
              <td class="text-center">{{ product.id }}</td>
              <td class="text-center">{{ product.identificationCode }}</td>
              <td class="p-productTable__td py-1">
                <div class="d-flex">
                  <img
                    v-if="productEyecatch(product)"
                    :src="productEyecatch(product)"
                    :alt="productEyecatchAlt(product).altAttribute"
                    class="p-productTable__td__image px-1"
                  />
                  <img
                    v-else
                    src="https://placehold.jp/eeeeee/cccccc/200x200.png?text=No%20Image"
                    alt="no-image"
                    class="p-productTable__td__image px-1"
                  />
                </div>
              </td>
              <td class="text-left">
                {{ product.name }}
              </td>
              <td class="text-center px-1 p-productTable__td">
                <v-btn
                  dark
                  outlined
                  small
                  color="indigo"
                  class="ma-2"
                  @click="$emit('select-product', product)"
                >
                  選択する
                </v-btn>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-col>
    </v-row>
    <infinite-loading
      spinner="spiral"
      class="mt-2"
      @infinite="infiniteHandler"
    >
      <template v-slot:no-more>
        <v-chip label outlined> 全て表示されました。 </v-chip>
      </template>
      <template v-slot:no-results>
        <v-chip label outlined> 表示できるものがありません。 </v-chip>
      </template>
    </infinite-loading>
  </v-card>
</template>

<script>
import axios from 'axios'
import Qs from 'qs'
import { deserialize } from 'deserialize-json-api'
import InfiniteLoading from 'vue-infinite-loading'
import imageUtilsMixin from '@/mixins/image_utils'

export default {
  name: 'ProductSelecter',
  components: {
    InfiniteLoading
  },
  mixins: [imageUtilsMixin],
  data: () => {
    return {
      page: 1,
      products: [],
      searchQuery: {
        name_or_identification_code_cont: ''
      }
    }
  },
  methods: {
    searchProducts () {
      this.page = 1
      this.products = []
      this.infiniteHandler()
    },
    productEyecatch (product) {
      if (!product.productImages) return

      const productImage = product.productImages.reduce((previousImage, currentImage) =>
        previousImage.priority > currentImage.priority
          ? currentImage
          : previousImage
      )
      return this.getFilePath(productImage.file.url)
    },
    productEyecatchAlt (product) {
      if (!product.productImages) return

      return product.productImages.reduce((previousImage, currentImage) =>
        previousImage.priority > currentImage.priority
          ? currentImage
          : previousImage
      )
    },
    infiniteHandler ($state) {
      axios
        .get('/api/products', {
          params: {
            page: this.page,
            q: this.searchQuery,
            only_published: true
          },
          paramsSerializer: function (params) {
            return Qs.stringify(params, { arrayFormat: 'brackets' })
          }
        })
        .then(({ data }) => {
          const fetchedProducts = deserialize(data).data

          if (fetchedProducts.length > 0) {
            this.page++
            this.products = this.products.concat(fetchedProducts)
            $state.loaded()
          } else {
            $state.complete()
          }
        })
    }
  }
}
</script>

<style scoped>
.p-productTable__td {
  vertical-align: middle;
}

.p-productTable__td__image {
  max-height: 100px;
  max-width: 100px;
}

.p-productTable__td__imageContent {
  place-self: center;
  vertical-align: middle;
}
</style>
